import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import type { Selectors } from '@makemydeal/dr-sales-checkin-store';
import { init } from '@makemydeal/dr-sales-checkin-store';
import type { IConfigSalesCheckin } from '@makemydeal/dr-sales-checkin-types';
import { additionalSelectors } from './additionalSelectors';
import { APP_NAME, SALESCHECKIN_ROOT_ROUTE } from './constants';

let salesCheckinSelectors: Selectors;

const hostActions = {};

export const configureSalesCheckin = (config: IConfigSalesCheckin) => {
    const { selectors, middlewareManager } = init(APP_NAME, additionalSelectors, hostActions, config, SALESCHECKIN_ROOT_ROUTE);
    salesCheckinSelectors = selectors;
    return middlewareManager;
};

export const getSalesCheckinSelectors = (): Selectors => salesCheckinSelectors;

export const getSalesCheckinConfigFromState = (state: any): IConfigSalesCheckin => {
    const featureToggles = featureToggleSelectors.getSimpleFeatureToggles(state);
    // TODO: fill with necessary config data
    const salesCheckinConfig = {
        services: {},
        featureToggles
    } as IConfigSalesCheckin;

    return salesCheckinConfig;
};
